<template>
    <BaseAccordion :accordion-ids="['insight']" class="insight-accordion" trigger-class="px-4">
        <template #trigger-insight>
            <div class="flex items-center gap-2 text-left">
                <span class="w-2.25 h-10 rounded-full bg-border" aria-hidden="true"></span>
                <span class="nadia-chat-bold">{{ insightTitle ?? firstSentence }}</span>
            </div>
        </template>
        <template #content-insight>
            <MarkdownText class="text-ink-muted nadia-chat px-4 py-3" :text="insight ?? restOfInsight" />
        </template>
    </BaseAccordion>
</template>

<script setup lang="ts">
/**
 * Serves double duty for displaying two similar widgets, the values insight widget and the internal thinking widget.
 * Both allow saving the insight to a conversation topic for later.
 */
import BaseAccordion from "~vue/components/BaseAccordion.vue";
import MarkdownText from "~vue/MarkdownText.vue";
import type { ParseActionsInternalThinkingAction, ParseActionsValuesInsightAction } from "~vue/types/chat";
import { computed } from "vue";

type ChatInsightAccordionProps = {
    data: ParseActionsInternalThinkingAction | ParseActionsValuesInsightAction;
};

const { data } = defineProps<ChatInsightAccordionProps>();

const insightTitle = computed(() => {
    return data.action_params.short_title;
});

const insight = computed(() => data.action_params.final_response);

const firstSentence = computed(() => {
    if (!insight.value) {
        return "";
    }
    return insight.value.split(". ")[0] + ".";
});

const restOfInsight = computed(() => {
    if (!insight.value) {
        return "";
    }
    return insight.value.split(". ").slice(1).join(". ");
});
</script>

<style scoped>
@reference "../../../css/tailwind.css";
.insight-accordion:deep() {
    .item {
        @apply shadow-none!;
    }
}
</style>
